import api, { apiWrapper } from '../api/axios';

export const getBranchUsers = async (
    {
    status = 'all', user_type='branch_user', search=null,
    page = 1, pageSize = 20, paginate = true
  }
) => {
  let params = {
    status,
    user_type,
    page,
    page_size: pageSize,
    paginate
  };
  if (search != null) {
    params = { ...params, search };
  }
  return apiWrapper(() => api.get(`/branch/users/`, { params }));
};

export const createBranchUser = async (data) => {
  return apiWrapper(() => api.post("/branch/users/", data));
};

export const updateBranchUser = async (id, data) => {
  return apiWrapper(() => api.put(`/branch/users/${id}/`, data));
};

export const updateBranchUsersPartial = async (id, data) => {
  return apiWrapper(() => api.patch(`/branch/users/${id}/`, data));
};

export const toggleBranchUserStatus = async (id, isActive) => {
  return apiWrapper(() => api.patch(`/branch/users/${id}/${isActive ? 'activate' : 'deactivate'}/`));
};

export const getProfile = async () => {
  return apiWrapper(() => api.get(`/branch/branch-user/profile/`));
};

export const updateProfile = async (data) => {
  return apiWrapper(() => api.patch(`/branch/branch-user/profile/`, data));
};

export const resetPassword = async (id, data) => {
  return apiWrapper(() => api.patch(`/branch/users/${id}/reset-password/`, data));
};
